module.exports = __webpack_public_path__ + "img/position.b11200d9.svg";